import { render, staticRenderFns } from "./RentPlanCard.vue?vue&type=template&id=63a76b5c&scoped=true"
import script from "./RentPlanCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RentPlanCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RentPlanCard.vue?vue&type=style&index=0&id=63a76b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a76b5c",
  null
  
)

export default component.exports